import type { BodyRouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { FileAssetsDataObject, FolderAssetDataObject, UpdateAssetRequest } from 'models/service';

export const updateAsset = async ({
  body,
  routeParams: { id },
}: BodyRouteParamsRequest<UpdateAssetRequest, { id: string }>) =>
  apiClient.put<
    FileAssetsDataObject | FolderAssetDataObject,
    ApiClientResponse<FileAssetsDataObject | FolderAssetDataObject>
  >(routes.assets.update(id), body);
